<template>
  <div>
    <el-table
      class="plc-table"
      max-height="500px"
      border
      :data="list"
      style="width: 100%"
    >
      <el-table-column prop="name" label="申请人"> </el-table-column>
      <el-table-column prop="companyName" label="申请公司"> </el-table-column>
      <el-table-column prop="industry" label="申请行业"> </el-table-column>
      <el-table-column prop="abilityStr" label="申请能力"> </el-table-column>
      <el-table-column prop="proofFiles" label="附件">
        <template slot-scope="scope">
          <a
            :href="item.url"
            target="_blank"
            v-for="(item, index) in scope.row.proofFiles"
            :key="index"
          >
            {{ item.fileName }}
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间"> </el-table-column>
      <el-table-column prop="approveRemark" label="审批备注"> </el-table-column>
    </el-table>
    <div style="text-align: center; padding-top: 18px" v-if="list.length && list[0].applyStatus === 1">
      <el-button size="small" class="plc-btn" @click="cancel">取消</el-button>
      <el-button type="primary" size="small" class="plc-btn" @click="confirm"
        >再次申请</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      const obj = {
        page: 1,
        limit: 10
      }
      this.$http
        .post('/front/oms/sso/supplier/applyRecords', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = res.data.records || []
          }
        })
    },
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      if (this.list.length === 0) {
        this.$emit('confirm', {})
      } else {
        this.$emit('confirm', this.list[0])
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
